<template>
  <div class="search-resoults">
    <b-table
      v-if="hasSearchResoults"
      striped
      hover
      no-local-sorting
      :items="getFilterItems"
      :fields="tableFields"
      @sort-changed="headClicked">

      <div
        slot="html"
        slot-scope="data"
        v-html="data.value" />

        <template slot="edit" slot-scope="row">
          <button
            class="row-button"
            @click="editItem(row)">

            <i class="fas fa-pencil-alt"></i>
          </button>
        </template>

        <template slot="view" slot-scope="row">
          <button
            class="row-button"
            @click="viewItem(row)">

            <i class="fas fa-eye"></i>
          </button>
        </template>

        <template slot="copy" slot-scope="row">
          <button
            v-if="row.item.typeName === 'campaign'"
            class="row-button"
            @click="copyItem(row.item)">

            <i class="far fa-clone"></i>
          </button>
        </template>

        <template slot="stats" slot-scope="row">
          <button
            class="row-button"
            @click="getStats(row)">

            ...
          </button>
        </template>

        <template slot="remove" slot-scope="row">
          <button
            class="row-button"
            @click="deleteItem(row)">

            <i class="far fa-trash-alt"></i>
          </button>
        </template>
    </b-table>
    <div
      class="text-center p-5"
      v-else>

      <h5>
        {{ $t('Search.noResults') }}
      </h5>
    </div>

    <pagination
      :total="getPaginationParams.total"
      :limit="getLimit"
      :current="getCurrentPage"
      @gotoPage="gotoPage" />

  </div>
</template>

<script>
import moment from 'moment'
import routingHelper from '@/assets/modules/routing/routingHelper'
import apiConnector from '@/mixins/apiConnector.js'
import fieldBuilder from '@/assets/modules/apollo/fieldBuilder'
import nManager from '@/assets/modules/notifications/manager'
import resolver from '@/assets/modules/error/resolver'
import paramExtractor from '@/assets/modules/channels/paramExtractor'
import duplicator from '@/mixins/pagination/providers/duplicator'
import search from '@/mixins/pagination/providers/search'
import Pagination from '@/components/standard/pagination/Pagination'

export default {
  data () {
    return {
      limit: 40,
      runExtraQuery: { mediaPlanEvents: true, campaigns: true, users: true }
    }
  },

  methods: {
    /**
     * Calls nth pagination page
     * @param {Number} e Requested page
     */
    gotoPage ({ page }) {
      this.requestNthPage(page)
    },

    editItem(e) {
      // Based on type open editor
      let typeName = e.item.typeName
      if (typeName === 'user') {
        this.$router.push({ name: 'userSettingsId', params: { uuid: e.item.id } })
      } else if (typeName === 'advertisable') {
        this.$router.push({ name: 'advertisableEditor', params: { postId: e.item.id } })
      } else if (typeName === 'campaign') {
        this.$router.push({ name: 'editCampaign', params: { id: e.item.id, view: 'grid' } })
      } else if (typeName === 'media_plan_event') {
        this.$router.push({ name: 'viewCampaigns', params: { style: 'grid', mpeId: e.item.id  } })
      }
    },

    // For not it will be the same as editItem
    viewItem(e) {
      // Based on type open editor
      let typeName = e.item.typeName
      if (typeName === 'user') {
        this.$router.push({ name: 'ImpersonateUser', params: { id: e.item.id } })
      } else {
        this.editItem(e)
      }
    },

    /**
     * Duplicates given item - Curently only campaigns
     * @param {Object} e
     */
    copyItem(e) {
      this.duplicateCampaign(e.id, e.eventType)
    },

    getStats(e) {
      // TODO: getStats
    },

    deleteItem(e) {
      // Based on type build a given delete mutation
      let gqlObject = {
        id: e.item.id
      }
      let mutationName = ''
      let { item: { typeName } } = e

      if (typeName === 'user') {
        mutationName = 'deleteUser'
      } else if (typeName === 'advertisable') {
        mutationName = 'deleteAdvertisable'
      } else if (typeName === 'campaign') {
        mutationName = 'deleteCampaign'
      } else if (typeName === 'media_plan_event') {
        mutationName = 'deleteMediaPlanEvent'
      }

      let okCallback = (e) => {
        this.refetchQueries()
        nManager.okNotification(this, `Notification.ok.deleteSuccess.label`)
      }

      // If seceret token failed to be created
      let failCallback = (_, e) => {
        let message = `Brisanje je spodletelo`
        message = resolver.resolve(e.message, message)
        nManager.nokNotification(this, message)
      }

      let {mutationString, dataObject, name} = fieldBuilder
        .buildGqlObject(gqlObject, mutationName, 'mutation')

      this.sendMutation(
        mutationString,
        dataObject,
        okCallback,
        failCallback,
        name)
    },

    // Makes a typeicon for the table
    getTypeIcon (type) {
      let label
      switch (type) {
        case 'campaign':
          label = 'C'
          break

        case 'advertisable':
          label = 'P'
          break

        case 'media_plan_event':
          label = 'P'
          break

        case 'user':
          label = 'U'
          break
      }

      return `<div class="type-circle ${type}">${label}</div>`
    },

    /**
     * Gets icons for given channels
     * @param {Array} channels
     * @returns {Array}
     */
    getIcons (channels) {
      let nChannels = Array.from(channels)
      let rtr = []

      for(let channel of channels) {
        let channelIcon = paramExtractor.extract(channel.type)
        let { pack, icon } = channelIcon
        rtr.push((this.$store.getters.qlogos[pack] || {})[icon])
      }

      return rtr
    },

    /**
     * Gives table header for search entry
     * @param {Object} resoult Object of resoult entry
     * @param {String} group Group of search resoult (user, campaign, ...)
     * @returns {String} HTML String
     */
    getCampaignLabels (resoult, group) {
      let channels = ''
      let credentials = []

      // Get credentials for given result type
      if (group === 'user') {
        // User has an array of credentials
        credentials = ((resoult.object.credentials || {}).set) || []
      } else if (group === 'campaign') {
        // Campaign has an array of events with possible same credentials... 
        // Filter them out with an object...
        let credentialSet = {}
        for (let event of (resoult.object.events || {}).set || []) {
          let credential = event.credentials || {}
          credentialSet[credential.id] = credential
        }

        credentials = Object.values(credentialSet)
      } else if (group === 'media_plan_event') {
        // MPE has 1 credential. Throw it in an array, set object.link as credential url
        let credential = JSON.parse(JSON.stringify((resoult.object.credentials || {})))
        credential.meta = credential.meta || {}
        credential.meta.credentialUrl = resoult.object.link
        credentials = [credential]
      }

      // Make icons for given credentials
      let icons = this.getIcons(credentials)
      for (let i = 0; i < icons.length; i++) {
        let icon = icons[i]
        let credentialUrl = (credentials[i].meta || {}).credentialUrl || '#'
        let tag = (credentialUrl === '#') ? 'span' : 'a'
        channels += `
          <${tag} href="${credentialUrl}" class="channel" target="_blank">
            <img src="${ icon }" width="100%" />
          </${tag}>
        `
      }

      // Label
      let base = `<div class="campaign-details"> <p class="campaign-label m-0">${ resoult.label }</p>`

      // Channels
      if (channels) base += `<div class="campaign-channels"> ${channels} </div> </div>`

      return base
    },

    /**
     * Gives Expires at date
     * @param {Object} resoult
     * @returns {String}
     */
    getDisplayDate (resoult) {
      if (!resoult.object || (!resoult.object.createdAt && !resoult.object.expiresAt && !resoult.object.publishAt)) return '/'
      let date = resoult.object.createdAt || resoult.object.expiresAt || resoult.object.publishAt
      return moment(date).format('D. M. YY')
    },

    /**
     * Gives status for given resoult
     * @param {Object} resoult
     * @returns {String}
     */
    getStatus (resoult) {
      if (!resoult.object) return '/'

      let status
      if (resoult.type === 'user') {
        if (resoult.object.lockedAt && !resolver.isSuperUser(resoult.object.roles)) status = 'userInactive'
        else status = 'userActive'

        return this.$t(this.getStatusI18Code(status))
      }

      return this.$t(this.getStatusI18Code(resoult.object.status))
    },

    /**
     * Gives i18 tag for given status
     * @param {String} status
     * @returns {String}
     */
    getStatusI18Code (status) {
      switch (status) {
        // Events
        case 'published':
          return 'Status.searchResoult.mpe.published'

        case 'publishQueued':
          return 'Status.searchResoult.mpe.publishQueued'

        case 'ready':
          return 'Status.searchResoult.mpe.publishQueued'

        case 'publishDeferred':
          return 'Status.searchResoult.mpe.publishDeferred'

        case 'publishFailed':
          return 'Status.searchResoult.mpe.publishFailed'

        // Campaigns
        case 'paused':
          return 'Status.searchResoult.campaign.paused'

        case 'archived':
          return 'Status.searchResoult.campaign.archived'

        case 'active':
          return 'Status.searchResoult.campaign.active'

        case 'draft':
          return 'Status.searchResoult.campaign.draft'

        // Users
        case 'userActive':
          return 'Status.searchResoult.user.active'

        case 'userInactive':
          return 'Status.searchResoult.user.inactive'

      }

      return '/'
    },
    
    headClicked (ctx) {
      let key = ctx.sortBy

      if (ctx.sortBy === 'campaign') {
        key = 'label'
      } else if (ctx.sortBy === 'expires') {
        key = 'createdAt'
      }
      this.sort(key, ctx.sortDesc)
      
      return null
    }
  },

  computed: {
    /**
     * Gives query string
     * @returns {String}
     */
    getQueryString () {
      if (!this.$route) return null
      return this.$route.params.query
    },

    /**
     * Gives available search resoult table fields. COmputed prop,
     * because of i18 and it's async translations
     * @returns {Object}
     */
    tableFields () {
      return {
        type: {
          label: this.$t('SearchResoults.table.header.type'),
          sortable: true
        },
        campaign: {
          label: this.$t('SearchResoults.table.header.campaign'),
          sortable: true
        },
        expires: {
          label: this.$t('SearchResoults.table.header.expires'),
          sortable: true
        },
        status: {
          label: this.$t('SearchResoults.table.header.status'),
          sortable: true
        },
        edit: {
          label: this.$t('SearchResoults.table.header.edit'),
          sortable: false
        },
        view: {
          label: this.$t('SearchResoults.table.header.view'),
          sortable: false
        },
        copy: {
          label: this.$t('SearchResoults.table.header.copy'),
          sortable: false
        },
        remove: {
          label: this.$t('SearchResoults.table.header.remove'),
          sortable: false
        }
      }
    },

    /**
     * Gives search resoults from vuex storage
     * @returns {Array}
     */
    getFilterResoults () {
      return this.getPaginatedList
    },

    /**
     * Gives array of campaigns to be queried
     * @returns {Array}
     */
    getQueryCampaigns () {
      let { campaign } = this.getFilterResoults
      return (campaign || []).map(c => c.object.id)
    },

    /**
     * Gives array of users to be queried
     * @returns {Array}
     */
    getQueryUsers () {
      let { user } = this.getFilterResoults
      return (user || []).map(u => u.object.id)
    },

    /**
     * Gives search resoults to be displayed in table
     * @returns {Array}
     */
    getFilterItems () {
      let filterResoults = this.getFilterResoults

      let rtr = []
      for (let group in filterResoults) {
        for (let resoult of filterResoults[group]) {
          let add = {
            type: this.getTypeIcon(group),
            campaign: this.getCampaignLabels(resoult, group),
            expires: this.getDisplayDate(resoult),
            status: this.getStatus(resoult),
            edit: 'e',
            view: 'v',
            copy: 'c',
            stats: 's',
            remove: 'r',
            id: resoult.id,
            typeName: resoult.type,
            eventType: resoult.object.campaignType
          }

          rtr.push(add)
        }
      }

      return rtr
    },

    /**
     * Tells if any search resoults available
     * @returns {Boolean}
     */
    hasSearchResoults () {
      return !!this.getFilterItems.length
    }
  },

  mixins: [
    apiConnector,
    duplicator,
    search,
  ],

  components: {
    'pagination': Pagination
  }
}
</script>

<style>
.type-circle {
  width: 50px;
  height: 50px;
  background-color: #353635;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-weight: bold;
}

.type-circle.advertisable, .type-circle.media_plan_event {
  background-color: #E2ECD7;
}
.type-circle.campaign {
  background-color: #D8E2FA;
}
.type-circle.user {
  background-color: #E6CAF8;
}

.campaign-channels .channel {
  width: 26px;
  height: 26px;
  border-radius: 100%;
  box-sizing: border-box;
  color: #353635;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  margin-right: 5px;
  margin-bottom: 5px;
}
.campaign-channels .channel:last-child {
  margin: 0;
}

.campaign-details .campaign-channels {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.row-button {
  display: flex;
  padding: 10px;
  margin: 0;
  background-color: transparent;
  border: 0!important;
  outline: 0!important;
  color: #353635;
  transition: all .3s;
  cursor: pointer;
}

.row-button:hover {
  color: #7AC143;
}

.row-button:active {
  outline: none;
}
.row-button:visited {
  outline: none;
}
.row-button:active {
  outline: none;
}

</style>



// WEBPACK FOOTER //
// src/components/service/search/SearchResoult.vue?0b2241f4